<template>
  <div class="d-flex flex-grow-1">
    <v-col class="pa-0" cols="5">
      <InputTabs />
    </v-col>
    <v-col class="pa-0" :class="$style.borderVertical">
      <OutputTabs />
    </v-col>
  </div>
</template>

<script>
import InputTabs from '@/components/InputTabs'
import OutputTabs from '@/components/OutputTabs'

export default {
  name: 'InputOutputContainer',

  components: {
    InputTabs,
    OutputTabs
  }
}
</script>

<style lang="scss" module>
.borderVertical {
  border-left: 1px solid rgba(#000, 0.12);
}
</style>
